import { prepareUrl } from '@/helpers/UrlHelpers';
import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';

export default class DoubleOptInSpoilerConfirmation {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * DoubleOptInSpoilerConfirmation constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Update customers spoiler preference to true.
     *
     * @param {Number} userId
     *
     * @returns {Promise}
     */
    handle(userId) {
        let url = prepareUrl(ApiEndpoints['users.preferences.double-optin-spoiler-confirmation.store'], [userId]);

        return this.apiService.post(url);
    }
}
